import { useEffect, useState } from "react";
import { apiFetch } from "../api/api";
import TenantForm from "../components/TenantForm";
import TenantTable from "../components/TenantTable";

export default function Tenants() {
  const [tenants, setTenants] = useState([]);
  const [editingTenant, setEditingTenant] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [documents, setDocuments] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});

  const fetchTenants = async () => {
    const data = await apiFetch("/tenants");
    setTenants(data);

    data.forEach((t) => fetchDocuments(t.id));
  };

  const fetchDocuments = async (tenantId) => {
    const docs = await apiFetch(`/documents/tenant/${tenantId}`);
    setDocuments((prev) => ({ ...prev, [tenantId]: docs }));
  };

  useEffect(() => {
    fetchTenants();
  }, []);

  const handleSubmit = async (form) => {
    if (editingTenant) {
      await apiFetch(`/tenants/${editingTenant.id}`, {
        method: "PATCH",
        body: JSON.stringify(form),
      });
    } else {
      await apiFetch("/tenants", {
        method: "POST",
        body: JSON.stringify(form),
      });
    }

    setEditingTenant(null);
    setShowForm(false);
    fetchTenants();
  };

  const deleteTenant = async (id) => {
    await apiFetch(`/tenants/${id}`, { method: "DELETE" });
    fetchTenants();
  };


  const uploadDocument = async (tenantId) => {
    const file = selectedFiles[tenantId];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    await apiFetch(`/documents/tenant/${tenantId}`, {
      method: "POST",
      body: formData,
    });

    fetchDocuments(tenantId);
  };

  const deleteDocument = async (docId, tenantId) => {
    await apiFetch(`/documents/${docId}`, { method: "DELETE" });
    fetchDocuments(tenantId);
  };

  return (
    <div>
      <h2>Tenants</h2>

      <button
        onClick={() => {
          setEditingTenant(null);
          setShowForm(true);
        }}
      >
        Add Tenant
      </button>

      <TenantTable
        tenants={tenants}
        documents={documents}
        selectedFiles={selectedFiles}
        onEdit={(t) => {
          setEditingTenant(t);
          setShowForm(true);
        }}
        onDelete={deleteTenant}
        onFileChange={(id, file) =>
          setSelectedFiles((prev) => ({ ...prev, [id]: file }))
        }
        onUpload={uploadDocument}
        onDeleteDoc={deleteDocument}
      />

      {showForm && (
        <TenantForm
          tenant={editingTenant}
          onSubmit={handleSubmit}
          onCancel={() => {
            setShowForm(false);
            setEditingTenant(null);
          }}
        />
      )}
    </div>
  );
}